import { PlusOutlined } from '@ant-design/icons'
import { Dropdown } from 'antd'
import { useState } from 'react'

import BrandCreationModal from '@/components/EntityCreationModals/BrandCreationModal/BrandCreationModal'
import CharacteristicCreationModal from '@/components/EntityCreationModals/CharacteristicCreationModal/CharacteristicCreationModal'
import TreeEntityCreationModal from '@/components/EntityCreationModals/TreeEntityCreationModal/TreeEntityCreationModal'

import ColumnCreationModal from '../PluralImport/ColumnCreationModal/ColumnCreationModal'
import { getDropdownItems } from './EntitiesCreationDropdown.config'
import cn from './EntitiesCreationDropdown.module.scss'

type EntitiesCreationDropdownPropsType = {
  onBrandCreated: () => void
  onCategoryCreated?: () => void
  onGroupCreated?: () => void
  onCharacteristicCreated?: () => void
  columnsKeys?: string[]
  setColumnsKeys?: (columnsKeys: string[]) => void
}

function EntitiesCreationDropdown(props: EntitiesCreationDropdownPropsType) {
  const {
    columnsKeys,
    onBrandCreated,
    onCategoryCreated,
    onGroupCreated,
    onCharacteristicCreated,
    setColumnsKeys,
  } = props

  const [openColumnCreationModal, setOpenColumnCreationModal] =
    useState<boolean>(false)
  const [openBrandCreationModal, setOpenBrandCreationModal] =
    useState<boolean>(false)
  const [openCategoryCreationModal, setOpenCategoryCreationModal] =
    useState<boolean>(false)
  const [
    openNomenclatureGroupCreationModal,
    setOpenNomenclatureGroupCreationModal,
  ] = useState<boolean>(false)
  const [openCharacteristicCreationModal, setOpenCharacteristicCreationModal] =
    useState<boolean>(false)

  return (
    <>
      {columnsKeys && setColumnsKeys && (
        <ColumnCreationModal
          open={openColumnCreationModal}
          setOpen={setOpenColumnCreationModal}
          columnsKeys={columnsKeys}
          setColumnsKeys={setColumnsKeys}
        />
      )}
      <BrandCreationModal
        open={openBrandCreationModal}
        setOpen={setOpenBrandCreationModal}
        onSuccess={onBrandCreated}
      />
      <CharacteristicCreationModal
        open={openCharacteristicCreationModal}
        setOpen={setOpenCharacteristicCreationModal}
        onSuccess={onCharacteristicCreated}
      />
      <TreeEntityCreationModal
        open={openCategoryCreationModal}
        setOpen={setOpenCategoryCreationModal}
        onSuccess={onCategoryCreated}
        treeType="categories"
      />
      <TreeEntityCreationModal
        open={openNomenclatureGroupCreationModal}
        setOpen={setOpenNomenclatureGroupCreationModal}
        onSuccess={onGroupCreated}
        treeType="nomenclature-groups"
      />
      <div className={cn.dropdown}>
        <Dropdown
          menu={{
            items: getDropdownItems({
              columnsKeys,
              setColumnsKeys,
              setOpenColumnCreationModal,
              setOpenBrandCreationModal,
              setOpenCharacteristicCreationModal,
              setOpenCategoryCreationModal,
              setOpenNomenclatureGroupCreationModal,
            }),
          }}
          getPopupContainer={(triggerNode) => triggerNode.parentElement!}
        >
          <div className={cn.dropdownTrigger}>
            <PlusOutlined />
          </div>
        </Dropdown>
      </div>
    </>
  )
}

export default EntitiesCreationDropdown
